export default "__VITE_ASSET__Cit4XcVa__"